import { useState, useEffect } from 'react';
import { YR, DOY } from '../lib/dateState.js';
import { isPhotoUrl, isThought, thoughtFontStyle } from '../lib/helpers.js';
import { fetchRemoteProfile, fetchRemoteBooks } from '../lib/api.js';
import { Btn, Back } from '../components/Basic.jsx';
import { BNav, mainNavItems } from '../components/Navigation.jsx';
import { MissingDayArt } from '../components/MissingDayArt.jsx';
import { NavIcon } from '../components/Navigation.jsx';
import { FilterTile } from '../components/FilterTile.jsx';
import { ShareSheet } from './Feed.jsx';
import { t as tr, LOCALE } from '../lib/i18n.js';
export function LibraryView({t,st,go,dispatch,username}){
  const isMe=!username;
  const [remoteBook,setRemoteBook]=useState(null);
  const [loadingRemote,setLoadingRemote]=useState(false);
  useEffect(()=>{
    if(isMe) return;
    let mounted=true;
    setLoadingRemote(true);
    (async()=>{
      const prof=await fetchRemoteProfile(username);
      if(!prof||!mounted){ setLoadingRemote(false); return; }
      const books=await fetchRemoteBooks(prof.id);
      if(mounted){ setRemoteBook(books[YR]||{pages:[]}); setLoadingRemote(false); }
    })();
    return ()=>{ mounted=false; };
  },[username,isMe]);
  const book=isMe?(st.books[YR]||{pages:[]}):(remoteBook||{pages:[]});
  const filled=book.pages?.length||0;
  const [sel,setSel]=useState(null);
  const [showExternal,setShowExternal]=useState(false);
  if(!isMe&&loadingRemote) return(
    <div className="screen fade" style={{background:t.bg,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
      <div style={{width:22,height:22,border:`2.5px solid ${t.ac}33`,borderTopColor:t.ac,borderRadius:"50%",animation:"spin .7s linear infinite"}}/>
    </div>
  );
  return(
    <div className="screen fade" style={{background:t.bg,display:"flex",flexDirection:"column"}}>
      <div style={{padding:"14px 14px 11px",display:"flex",alignItems:"center",gap:11,borderBottom:`1px solid ${t.ac}18`,flexShrink:0}}>
        <Back fn={()=>go(isMe?"profile":"profile_"+username)} t={t}/>
        <span style={{fontSize:17,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif"}}>{isMe?tr("lib_header_title_mine",{year:YR}):tr("lib_header_title_other",{year:YR,username})}</span>
        <div style={{marginLeft:"auto",display:"flex",alignItems:"center",gap:7,background:t.card,borderRadius:40,padding:"5px 10px",border:`1px solid ${t.bord}`}}>
          <div style={{width:50,height:3,background:t.soft+"22",borderRadius:2,overflow:"hidden"}}><div style={{height:"100%",width:`${(filled/365)*100}%`,background:t.pill,borderRadius:2}}/></div>
          <span style={{fontSize:10,color:t.soft,fontFamily:"Inter,sans-serif"}}>{filled}/365</span>
        </div>
      </div>
      <div style={{padding:14,flex:1,overflowY:"auto"}}>
        <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:4,marginBottom:16}}>
          {Array.from({length:DOY}).map((_,i)=>{
            const d=DOY-i;
            const pg=book.pages?.find(p=>p.day===d);
            const isToday=d===DOY;
            return(
              <div key={i} onClick={()=>pg&&setSel(pg)} style={{aspectRatio:"1",borderRadius:5,background:pg?t.ac+"33":isToday?t.ac+"18":t.card,border:isToday?`1.5px solid ${t.ac}`:`1px solid ${t.bord}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:pg?13:8,cursor:pg?"pointer":"default",transition:"transform .12s",overflow:"hidden",position:"relative"}}
                onMouseEnter={e=>pg&&(e.currentTarget.style.transform="scale(1.12)")}
                onMouseLeave={e=>(e.currentTarget.style.transform="scale(1)")}>
                {pg
                  ? (isPhotoUrl(pg.photo)
                      ? <img src={pg.photo} loading={i<21?"eager":"lazy"} style={{position:"absolute",inset:0,width:"100%",height:"100%",objectFit:"cover",filter:(st.filters.find(f=>f.id===pg.filter)||{}).css||"none"}}/>
                      : isThought(pg.photo)
                        ? <div style={{position:"absolute",inset:0,background:`linear-gradient(135deg,${t.ac}26,${t.ac2||t.ac}12)`,display:"flex",alignItems:"center",justifyContent:"center",padding:2,overflow:"hidden"}}>
                            <span style={{...thoughtFontStyle(pg.photo),fontSize:6.5,lineHeight:1.15,color:t.tx,textAlign:"center",display:"-webkit-box",WebkitLineClamp:4,WebkitBoxOrient:"vertical",overflow:"hidden"}}>{pg.caption||"✏️"}</span>
                          </div>
                        : <span style={{filter:(st.filters.find(f=>f.id===pg.filter)||{}).css||"none"}}>{pg.photo}</span>)
                  : isToday?<span style={{color:t.ac,zIndex:1}}>●</span>:<><MissingDayArt day={d} year={YR} theme={t.id||st.myTheme}/><span style={{position:"relative",zIndex:1,color:"rgba(255,255,255,.55)",fontWeight:600,textShadow:"0 1px 2px rgba(0,0,0,.3)"}}>{d}</span></>}
              </div>
            );
          })}
        </div>
        {filled>0?(
          <>
            <div style={{fontSize:10,fontWeight:700,color:t.soft,fontFamily:"Inter,sans-serif",letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:10}}>{tr("lib_recent_pages")}</div>
            {book.pages.slice(-5).reverse().map((pg,i)=>(
              <div key={i} onClick={()=>setSel(pg)} style={{background:t.card,borderRadius:13,padding:"10px 12px",display:"flex",alignItems:"center",gap:10,marginBottom:8,border:`1px solid ${t.bord}`,cursor:"pointer"}}>
                <FilterTile filter={st.filters.find(f=>f.id===pg.filter)} emoji={pg.photo} size={42}/>
                <div style={{flex:1}}>
                  <div style={{fontSize:10,color:t.soft,fontFamily:"Inter,sans-serif",marginBottom:2}}>{tr("lib_page_label",{day:pg.day})}</div>
                  {pg.caption&&<div style={{fontSize:13,color:t.tx,fontFamily:"Inter,sans-serif",fontStyle:"italic",lineHeight:1.35}}>{pg.caption}</div>}
                </div>
                {pg.day===DOY&&<div style={{fontSize:8,padding:"3px 7px",borderRadius:20,background:t.ac,color:"#fff",fontFamily:"Inter,sans-serif",fontWeight:700}}>{tr("lib_today_badge")}</div>}
              </div>
            ))}
          </>
        ):(
          <div style={{textAlign:"center",padding:"36px 20px"}}>
            <div style={{fontSize:40,marginBottom:12}}>📖</div>
            <div style={{fontSize:15,fontWeight:700,color:t.tx,fontFamily:"Inter,sans-serif",marginBottom:7}}>{isMe?tr("lib_empty_title_mine",{year:YR}):tr("lib_empty_title_other",{username})}</div>
            {isMe&&<div style={{fontSize:12,color:t.soft,fontFamily:"Inter,sans-serif",marginBottom:18}}>{tr("lib_empty_subtitle")}</div>}
            {isMe&&<Btn fn={()=>go("capture")} style={{background:t.pill,color:"#fff",padding:"12px 26px",borderRadius:40,fontSize:13,fontWeight:700,fontFamily:"Inter,sans-serif",display:"inline-block"}}>{tr("lib_empty_cta")}</Btn>}
          </div>
        )}
      </div>
      {isMe&&filled>0&&(
        <div style={{padding:"11px 14px 14px",flexShrink:0,borderTop:`1px solid ${t.bord}`}}>
          <Btn full fn={()=>go("print_preview",{book:{type:"annual",year:YR,title:`Il tuo ${YR}`,theme:st.myTheme||t.id,pages:book.pages}})} style={{background:t.pill,color:"#fff",padding:"14px",borderRadius:40,fontSize:14,fontWeight:700,fontFamily:"Inter,sans-serif",textAlign:"center",boxShadow:`0 6px 18px ${t.ac}44`}}>{tr("lib_print_cta")}</Btn>
        </div>
      )}
      {isMe&&<BNav t={t} items={mainNavItems("library",t,go,st)}/>}
      {sel&&(
        <div className="overlay" onClick={()=>setSel(null)}>
          <div className="sheet" onClick={e=>e.stopPropagation()}>
            <div style={{padding:"14px 15px 6px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span style={{fontSize:14,fontWeight:700,fontFamily:"Inter,sans-serif",color:"#1a1a1a"}}>{tr("lib_page_detail_title",{day:sel.day,year:YR})}</span>
              <span onClick={()=>setSel(null)} style={{cursor:"pointer",fontSize:20,color:"#aaa"}}>✕</span>
            </div>
            <div style={{padding:"0 15px 26px"}}>
              <div style={{display:"flex",justifyContent:"center",marginBottom:12}}>
                <FilterTile filter={st.filters.find(f=>f.id===sel.filter)} emoji={sel.photo} size={320}/>
              </div>
              {sel.filter&&sel.filter!=="none"&&<div style={{textAlign:"center",fontSize:10.5,color:t.ac,fontFamily:"Inter,sans-serif",fontWeight:700,marginBottom:10}}>🎞 {(st.filters.find(f=>f.id===sel.filter)||{}).name}</div>}
              {sel.caption&&<div style={{fontSize:15,fontFamily:"Inter,sans-serif",color:"#1a1a1a",fontStyle:"italic",lineHeight:1.55,marginBottom:10}}>"{sel.caption}"</div>}
              <div style={{fontSize:11,color:"#888",fontFamily:"Inter,sans-serif"}}>📅 {new Date(YR,0,sel.day).toLocaleDateString(LOCALE,{weekday:"long",day:"numeric",month:"long"})}</div>
              <div onClick={()=>setShowExternal(true)} style={{marginTop:11,display:"flex",alignItems:"center",justifyContent:"center",gap:6,padding:"11px",borderRadius:12,background:"linear-gradient(135deg,#FF2D6B,#7B2FFF)",color:"#fff",fontSize:12.5,fontWeight:700,fontFamily:"Inter,sans-serif",cursor:"pointer"}}>
                <NavIcon type="share" active={false} soft="#fff" size={14}/> {tr("lib_share_external")}
              </div>
              <div style={{marginTop:9,padding:"9px 12px",borderRadius:9,background:"#f4f4f4",fontSize:11,fontFamily:"Inter,sans-serif",color:"#777"}}>{tr("lib_permanent_notice")}</div>
            </div>
          </div>
          {showExternal&&<ShareSheet item={{...sel,user:isMe?(st.profile.username||"tu"):username}} filter={st.filters.find(f=>f.id===sel.filter)} ut={t} onClose={()=>setShowExternal(false)} dispatch={dispatch}/>}
        </div>
      )}
    </div>
  );
}
